import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerSiteComponent} from './customer-site.component';
const routes: Routes = [
  {
    path: '',
    component: CustomerSiteComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerSiteRoutingModule { }
